import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

export const redirectTo404 = (router: Router) => {
  return new RedirectCommand(router.parseUrl('/404'), {
    state: { error: true },
  });
};

export const navigateTo404 = (router: Router) => {
  void router.navigate(['/404'], { state: { error: true } });
};

/** The 404 page is only reachable when explicitly navigate to with
 * specific router state. Otherwise, a root redirect is performed.
 *
 * It should be shown when:
 * - there is no instance available
 * - no templates are matched for the current instance
 * - no templates are matched for any additional conditions */
export const canActivate404: CanActivateFn = () => {
  const router = inject(Router);
  const validNavigation =
    router.getCurrentNavigation().extras?.state?.['error'] === true;
  if (validNavigation) {
    return validNavigation;
  }
  return router.createUrlTree(['/']);
};
